import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/App";

export default function CookieConsent() {
  const { t, L } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.location.pathname.startsWith("/admin")) return;
    const guardado = localStorage.getItem("lc-cookies");
    if (!guardado) setVisible(true);
  }, []);

  const decidir = (v) => {
    localStorage.setItem("lc-cookies", v);
    setVisible(false);
  };

  if (!visible) return null;
  const c = t.global.cookies;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[70] mx-auto max-w-md border border-lineas bg-sand p-5 shadow-2xl shadow-ink/20 md:left-6 md:right-auto md:bottom-6" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <Cookie size={20} strokeWidth={1.6} className="mt-0.5 shrink-0 text-terra" />
        <p className="text-[13px] leading-relaxed text-ink-soft">{c.texto}</p>
      </div>
      <div className="mt-4 flex items-center gap-2">
        <button
          onClick={() => decidir("accepted")}
          className="bg-terra px-4 py-2 text-[10px] font-bold tracking-[0.18em] text-sand transition-colors hover:bg-terra-dark"
          data-testid="cookie-aceptar-btn"
        >
          {c.aceptar}
        </button>
        <button
          onClick={() => decidir("rejected")}
          className="border border-ink/25 px-4 py-2 text-[10px] font-bold tracking-[0.18em] text-ink transition-colors hover:border-terra hover:text-terra"
          data-testid="cookie-rechazar-btn"
        >
          {c.rechazar}
        </button>
        <Link to={L("cookies")} className="ml-auto text-[11px] text-ochre underline underline-offset-2 hover:text-terra" data-testid="cookie-mas-info-link">
          {c.masInfo}
        </Link>
      </div>
    </div>
  );
}